import React from 'react';
import { createPortal } from 'react-dom';
import { LogOut } from 'lucide-react';

/**
 * Reusable "Are you sure you want to log out?" confirmation.
 * Controlled: pass `open`, `onCancel`, `onConfirm`.
 * Rendered through a portal to <body> so it escapes any parent stacking
 * context (e.g. the rider Personal-info page) and always paints above the
 * bottom navigation.
 */
const LogoutConfirmModal = ({ open, onCancel, onConfirm }) => {
  if (!open) return null;
  return createPortal(
    <div
      className="fixed inset-0 z-[2000] flex items-end sm:items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
      onClick={onCancel}
      data-testid="logout-confirm-modal"
    >
      <div
        className="w-full max-w-sm mb-4 sm:mb-0 bg-white dark:bg-gray-800 rounded-3xl shadow-2xl p-6 text-center animate-in fade-in zoom-in-95 duration-150"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-14 h-14 mx-auto rounded-full bg-rose-100 flex items-center justify-center mb-4">
          <LogOut className="w-7 h-7 text-rose-600" />
        </div>
        <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-1">Log out?</h3>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">
          Are you sure you want to log out of Ride Yachangu?
        </p>
        <div className="flex gap-3">
          <button
            type="button"
            onClick={onCancel}
            data-testid="logout-confirm-cancel"
            className="flex-1 h-12 rounded-2xl bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-100 font-semibold active:scale-[0.98] transition-transform"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            data-testid="logout-confirm-confirm"
            className="flex-1 h-12 rounded-2xl bg-rose-600 hover:bg-rose-700 text-white font-semibold active:scale-[0.98] transition-all"
          >
            Log out
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LogoutConfirmModal;
